import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FileUploader from '../../../components/FileUploader/FileUploader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useMemo, memo } from 'react';
import './MarkinVariants.css';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const MarkingAttachment = memo(({ id, question, assessmentId, record, disabled }) => {
  const { answer = [], title } = question;
  const [openModal, setOpenModal] = useState(false);

  const handleClickOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const getAnswerLabel = useMemo(() => {
    return answer?.length ? `${answer?.length} file${answer?.length > 1 ? 's' : ''}` : '';
  }, [answer]);

  return (
    <Box id={id}>
      <>
        <Chip
          style={{ width: 100 }}
          className={`clickeable text-clickeable chip-clickeable ${answer.length ? '' : 'bg-fourth-orange'} ${
            openModal ? 'selected-chip' : ''
          }`}
          label={getAnswerLabel}
          onClick={disabled ? undefined : handleClickOpen}
          disabled={disabled}
          icon={
            <FontAwesomeIcon
              icon={'paperclip'}
              style={{ fontSize: '1.2em', color: '#4e5459', marginRight: answer.length ? '2px' : '0px' }}
            />
          }
        />
        <Dialog open={openModal} fullWidth={true} maxWidth={'md'}>
          <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title'>
            {title || ''}
            <IconButton
              aria-label='close'
              onClick={handleClose}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500]
              })}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <FileUploader
              question={question}
              record={record}
              assessmentId={assessmentId}
              handleClose={handleClose}
            />
          </DialogContent>
          <DialogActions>
            <Button
              size='large'
              color='primary'
              onClick={handleClose}
              variant='outlined'
              className='shadow-sm'
              startIcon={<FontAwesomeIcon icon='times' />}
              style={{ padding: '6px 16px', height: '40px' }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </Box>
  );
});

export default MarkingAttachment;
